module.exports = __webpack_public_path__ + "img/tutorial.48f6573e.png";